import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSeparateVideoVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSeparateVideoVoice"><Path fillRule="evenodd" clipRule="evenodd" d="M14 22H12V19H2V5H12V2H14V22ZM4.25 17H6.75V15H4.25V17ZM9.25 17H11.75V15H9.25V17ZM4.25 9H6.75V7H4.25V9ZM9.25 9H11.75V7H9.25V9Z" fill="currentColor"/><Path d="M20 19H18V5H20V19Z" fill="currentColor"/><Path d="M17 16H15V8H17V16Z" fill="currentColor"/><Path d="M23 14.5H21V9.5H23V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSeparateVideoVoice;
